import React, { useState } from 'react';

import { connect } from 'react-redux';

import { AppDispatch } from 'redux-types';
import { AppState } from '@redux/types';
import { ApplicationPrices } from '@redux/reducers/applications/types';
import { SalesState } from '@redux/reducers/sales/types';
import {
  _getCaApp,
  _getPrices,
  _isLoadingApps,
} from '@redux/reducers/applications/selectors';
import { _getCurrency } from '@redux/reducers/profile/selectors';
import { _getSales } from '@redux/reducers/sales/selectors';
import { _isAddingToBasket } from '@redux/reducers/basket/selectors';
import { addProductsToBasket } from '@redux/reducers/basket/action';
import { compose } from 'redux';
import { showChangePurchasedSubscriptionPopup } from '@redux/reducers/popups/action';

import ChangePurchasedSubscriptionPopup from '@components/organisms/ChangePurchasedSubscriptionPopup';
import Layout from '@components/organisms/Layout/Layout';

import OfferTemplate from '@components/templates/OfferTemplate';

import { ROUTE } from '@utils/index';

import isValidPromo from '@utils/isValidPromo';

import { Currency } from '@shared/interfaces/currency';
import { HeaderType } from '@shared/markup/constants';
import { NextFCWithInitialProps, getInitialProps } from '@lib/getInitialProps';
import { Product } from '@shared/interfaces/product';

import Router, { withRouter } from 'next/router';
import { Sale } from '@shared/interfaces/sale';
import { WithRouterProps } from 'next/dist/client/with-router';

type OfferProps = WithRouterProps & {
  dispatch: AppDispatch;
  application: Product;
  currency: Currency;
  isLoadingApps: boolean;
  isAddingToBasket: boolean;
  sale: Sale | SalesState;
  prices: ApplicationPrices[];
};

const Offer: NextFCWithInitialProps<OfferProps> = ({
  sale,
  prices,
  router,
  currency,
  dispatch,
  application,
  isLoadingApps,
  isAddingToBasket,
}) => {
  const [state, setState] = useState({
    isChangedPurchased: false,
  });

  const promo = router.query?.promo as string;
  const isPromo = isValidPromo(promo);
  const navbarTitle = isPromo ? '' : sale.navbar_title;

  const handleAddToBasket = products => {
    dispatch(addProductsToBasket(products)).then(() => {
      const url = new URL(ROUTE.CHECKOUT.SELECT, window.location.origin);

      if (isPromo) {
        url.searchParams.set('promo', promo);
      }
      
      Router.push(url.toString());
    });
  };

  const handleShowChangePurchasedSubscriptionPopup = () => {
    dispatch(showChangePurchasedSubscriptionPopup());
  };

  return (
    <Layout headerType={HeaderType.Ca} discount={navbarTitle}>
      <OfferTemplate
        application={application}
        currency={currency}
        isLoadingApps={isLoadingApps}
        onAddToBasket={handleAddToBasket}
        isAddingToBasket={isAddingToBasket}
        sale={sale}
        onShowChangePurchasedSubscriptionPopup={
          handleShowChangePurchasedSubscriptionPopup
        }
        prices={prices}
        promo={isPromo}
      />

      <ChangePurchasedSubscriptionPopup />
    </Layout>
  );
};

Offer.getInitialProps = getInitialProps();

const withConnect = connect((state: AppState) => {
  const application = _getCaApp(state);

  return {
    application,
    currency: _getCurrency(state),
    isLoadingApps: _isLoadingApps(state),
    isAddingToBasket: _isAddingToBasket(state),
    sale: _getSales(state, application.id),
    prices: _getPrices(state),
  };
});

export default compose(withRouter, withConnect)(Offer);
